import React, { useEffect } from "react";

const HomePage = () => {
  useEffect(() => {
    var s = document.createElement("script");
    s.src = "/js/main.js";
    document.body.appendChild(s);
  }, []);

  const get_sign_up = () => {
    const url = `${process.env.REACT_APP_OPENID_SIGNIN_URL}`;
    return url;
  };

  return (
    <>
      <section id="home-section" className="hero">
        <h3 className="vr">Alpis Studio</h3>
        <div className="home-slider js-fullheight owl-carousel">
          <div className="slider-item js-fullheight">
            <div className="overlay" />
            <div className="container-fluid p-0">
              <div
                className="row d-md-flex no-gutters slider-text js-fullheight align-items-center justify-content-end"
                data-scrollax-parent="true"
              >
                <div
                  className="one-third order-md-last img js-fullheight"
                  style={{ backgroundImage: "url(images/bg_1.jpg)" }}
                >
                  <div className="overlay"></div>
                </div>
                <div
                  className="one-forth d-flex js-fullheight align-items-center ftco-animate"
                  data-scrollax=" properties: { translateY: '70%' }"
                >
                  <div className="text">
                    <span className="subheading">
                      Bem vindo ao Alpis Studio
                    </span>
                    <h1 className="mb-4 mt-3">
                      O <span>Futuro</span> da Tomada de <span>Decisões</span>{" "}
                      em <span>Investimentos</span>
                    </h1>
                    <p>
                      Imagine ter ao seu lado não apenas ferramentas, mas
                      verdadeiros aliados estratégicos que oferecem análises
                      precisas em tempo real.
                    </p>
                    <p>
                      <a
                        className="btn btn-primary px-5 py-3 mt-3"
                        href={get_sign_up()}
                      >
                        Criar conta
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="slider-item js-fullheight">
            <div className="overlay" />
            <div className="container-fluid p-0">
              <div
                className="row d-md-flex no-gutters slider-text js-fullheight align-items-center justify-content-end"
                data-scrollax-parent="true"
              >
                <div
                  className="one-third order-md-last img js-fullheight"
                  style={{ backgroundImage: "url(images/bg_1.jpg)" }}
                >
                  <div className="overlay"></div>
                </div>
                <div
                  className="one-forth d-flex js-fullheight align-items-center ftco-animate"
                  data-scrollax=" properties: { translateY: '70%' }"
                >
                  <div className="text">
                    <span className="subheading">
                      Bem vindo ao Alpis Studio
                    </span>
                    <h1 className="mb-4 mt-3">
                      <span>Soluções</span> computacionais avançadas e{" "}
                      <span>ferramentas</span> analíticas <span>poderosas</span>
                    </h1>
                    <p>
                      No Alpis Studio, nós fornecemos soluções computacionais
                      avançadas e ferramentas analíticas poderosas que são mais
                      do que simples assistentes; são o seu principal recurso
                      para otimizar a performance dos seus investimentos.
                    </p>
                    <p>
                      <a
                        className="btn btn-primary px-5 py-3 mt-3"
                        href={get_sign_up()}
                      >
                        Criar conta
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="slider-item js-fullheight">
            <div className="overlay" />
            <div className="container-fluid p-0">
              <div
                className="row d-md-flex no-gutters slider-text js-fullheight align-items-center justify-content-end"
                data-scrollax-parent="true"
              >
                <div
                  className="one-third order-md-last img js-fullheight"
                  style={{ backgroundImage: "url(images/bg_1.jpg)" }}
                >
                  <div className="overlay"></div>
                </div>
                <div
                  className="one-forth d-flex js-fullheight align-items-center ftco-animate"
                  data-scrollax=" properties: { translateY: '70%' }"
                >
                  <div className="text">
                    <span className="subheading">
                      Bem vindo ao Alpis Studio
                    </span>
                    <h1 className="mb-4 mt-3">
                      Claro, <span>assertivo</span> e, acima de tudo,{" "}
                      <span>eficaz</span>
                    </h1>
                    <p>
                      Com nossas soluções, a tomada de decisões complexas se
                      torna um processo mais claro, assertivo e, acima de tudo,
                      eficaz. Não se contente com menos; escolha a inteligência
                      e eficiência que somente o Alpis Studio pode oferecer.
                    </p>
                    <p>
                      <a
                        className="btn btn-primary px-5 py-3 mt-3"
                        href={get_sign_up()}
                      >
                        Criar conta
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="ftco-section ftco-no-pb ftco-no-pt ftco-services bg-light"
        id="services-section"
      >
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-4 ftco-animate py-5 nav-link-wrap">
              <div
                className="nav flex-column nav-pills"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <a
                  className="nav-link px-4 active"
                  id="v-pills-1-tab"
                  data-toggle="pill"
                  href="#v-pills-1"
                  role="tab"
                  aria-controls="v-pills-1"
                  aria-selected="true"
                >
                  <span className="mr-3 flaticon-ideas" />
                  Expert Advisors
                </a>
                <a
                  className="nav-link px-4"
                  id="v-pills-2-tab"
                  data-toggle="pill"
                  href="#v-pills-2"
                  role="tab"
                  aria-controls="v-pills-2"
                  aria-selected="false"
                >
                  <span className="mr-3 flaticon-flasks" />
                  Ferramentas para opções
                </a>
                <a
                  className="nav-link px-4"
                  id="v-pills-3-tab"
                  data-toggle="pill"
                  href="#v-pills-3"
                  role="tab"
                  aria-controls="v-pills-3"
                  aria-selected="false"
                >
                  <span className="mr-3 flaticon-analysis" />
                  Gerenciamento de operações
                </a>
                <a
                  className="nav-link px-4"
                  id="v-pills-4-tab"
                  data-toggle="pill"
                  href="#v-pills-4"
                  role="tab"
                  aria-controls="v-pills-4"
                  aria-selected="false"
                >
                  <span className="mr-3 flaticon-web-design" />
                  Grade de opções o vivo
                </a>
                <a
                  className="nav-link px-4"
                  id="v-pills-5-tab"
                  data-toggle="pill"
                  href="#v-pills-5"
                  role="tab"
                  aria-controls="v-pills-5"
                  aria-selected="false"
                >
                  <span className="mr-3 flaticon-ux-design" />
                  Rentabilidade do Portfólio
                </a>
              </div>
            </div>
            <div className="col-md-8 ftco-animate p-4 p-md-5 d-flex align-items-center">
              <div className="tab-content pl-md-5" id="v-pills-tabContent">
                <div
                  className="tab-pane fade show active py-5"
                  id="v-pills-1"
                  role="tabpanel"
                  aria-labelledby="v-pills-1-tab"
                >
                  <span className="icon mb-3 d-block flaticon-ideas" />
                  <h2 className="mb-4">Expert Advisors</h2>
                  <h4>
                    Transforme sua Estratégia de Investimento com Nossos Expert
                    Advisors
                  </h4>
                  <p style={{ textAlign: "justify" }}>
                    Imagine contar com uma equipe de analistas especializados,
                    mas sem a necessidade de contratar um exército de
                    consultores. Nossos Expert Advisors oferecem muito mais do
                    que simples análises: eles entregam insights poderosos,
                    meticulosamente calculados para ampliar os retornos do seu
                    portfólio a longo prazo. Utilizamos rotinas inteligentes e
                    algoritmos avançados para decifrar as nuances do mercado de
                    forma quantitativa. O resultado? Um processo de análise de
                    investimento mais simples, mais eficiente e, acima de tudo,
                    mais lucrativo para você.
                  </p>
                  <p>
                    <a
                      href={get_sign_up()}
                      className="btn btn-primary px-4 py-3"
                    >
                      Saiba mais
                    </a>
                  </p>
                </div>
                <div
                  className="tab-pane fade py-5"
                  id="v-pills-2"
                  role="tabpanel"
                  aria-labelledby="v-pills-2-tab"
                >
                  <span className="icon mb-3 d-block flaticon-flasks" />
                  <h2 className="mb-4">Ferramentas para o mercado de opções</h2>
                  <h4>
                    Domine o Mercado de Opções com Nossas Ferramentas Exclusivas
                  </h4>
                  <p style={{ textAlign: "justify" }}>
                    Quer ter uma vantagem competitiva no volátil mercado de
                    opções? Com nossas ferramentas inovadoras, você não só
                    visualiza o mercado de uma forma estratégica, como também
                    gerencia suas operações de maneira incrivelmente simples e
                    intuitiva. Planeje e simule suas transações com precisão
                    cirúrgica e monitore em tempo real o desempenho de suas
                    operações. Simplifique a complexidade e torne sua estratégia
                    de investimento em opções mais eficaz e rentável do que
                    nunca.
                  </p>
                  <p>
                    <a
                      href={get_sign_up()}
                      className="btn btn-primary px-4 py-3"
                    >
                      Saiba mais
                    </a>
                  </p>
                </div>
                <div
                  className="tab-pane fade py-5"
                  id="v-pills-3"
                  role="tabpanel"
                  aria-labelledby="v-pills-3-tab"
                >
                  <span className="icon mb-3 d-block flaticon-analysis" />
                  <h2 className="mb-4">Timeline das suas operações</h2>
                  <h4>
                    Tenha o Controle Total com a Timeline das Suas Operações
                  </h4>
                  <p style={{ textAlign: "justify" }}>
                    Já imaginou ter um painel de controle dinâmico que não
                    apenas registra, mas também analisa o seu histórico de
                    operações no mercado? Com nossa funcionalidade de "Timeline
                    das Operações," você poderá fazer exatamente isso. Acompanhe
                    a evolução do seu portfólio, de vencimento a vencimento, e
                    obtenha uma visão clara do seu progresso e áreas para
                    melhoria. Não deixe seus investimentos ao acaso. Mantenha-se
                    organizado, tome decisões mais informadas e maximize seus
                    retornos com nossa ferramenta intuitiva e poderosa.
                  </p>
                  <p>
                    <a
                      href={get_sign_up()}
                      className="btn btn-primary px-4 py-3"
                    >
                      Saiba mais
                    </a>
                  </p>
                </div>
                <div
                  className="tab-pane fade py-5"
                  id="v-pills-4"
                  role="tabpanel"
                  aria-labelledby="v-pills-4-tab"
                >
                  <span className="icon mb-3 d-block flaticon-web-design" />
                  <h2 className="mb-4">Grade de opções com preço ao vivo</h2>
                  <h4>
                    Acesso em Tempo Real à Grade de Opções: Integração Total,
                    Decisões Mais Rápidas!
                  </h4>
                  <p style={{ textAlign: "justify" }}>
                    Você está cansado de alternar entre várias plataformas para
                    acompanhar os preços das opções? Nós temos a solução
                    perfeita! Integre suas plataformas conosco e obtenha acesso
                    ao vivo à grade de opções. Isso significa que você pode
                    tomar decisões informadas mais rapidamente do que nunca,
                    diretamente de um painel unificado. Não perca mais tempo ou
                    oportunidades valiosas. Sincronize sua estratégia de
                    investimento com a realidade do mercado em tempo real, e dê
                    um impulso instantâneo na sua performance.
                  </p>
                  <p>
                    <a
                      href={get_sign_up()}
                      className="btn btn-primary px-4 py-3"
                    >
                      Saiba mais
                    </a>
                  </p>
                </div>
                <div
                  className="tab-pane fade py-5"
                  id="v-pills-5"
                  role="tabpanel"
                  aria-labelledby="v-pills-5-tab"
                >
                  <span className="icon mb-3 d-block flaticon-ux-design" />
                  <h2 className="mb-4">Rentabilidade do Portfólio</h2>
                  <h4>
                    Maximize a Rentabilidade do Seu Portfólio com Controle
                    Absoluto
                  </h4>
                  <p style={{ textAlign: "justify" }}>
                    Quer transformar seus investimentos em uma máquina de renda?
                    Com nossa funcionalidade de "Rentabilidade do Portfólio,"
                    você tem o poder de rastrear cada detalhe da performance dos
                    seus investimentos. Além disso, divida suas operações em
                    diferentes carteiras para obter uma visão granular e focada
                    da sua estratégia de investimento. Não fique no escuro.
                    Tenha insights valiosos, identifique tendências e tome
                    decisões mais assertivas para impulsionar sua performance no
                    mercado.
                  </p>
                  <p>
                    <a
                      href={get_sign_up()}
                      className="btn btn-primary px-4 py-3"
                    >
                      Saiba mais
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default HomePage;
